import { useContext } from 'react';
import __ from "lodash";
import SystemContext from '../../SystemContext';

const getStatusColour = (colours, status) => {
  if (colours) {
    if (__.has(colours, `${status}`)){   
      return colours[`${status}`];
    }
    if (__.has(colours, `DEFAULT`)){   
      return colours[`DEFAULT`];
    }
  }
  return null;
}

const useColour = (props) => {
  const SystemData = useContext(SystemContext);
  const code = props.code; 
  const status = props.status; 

  const colours = SystemData.colours;

  if (Array.isArray(colours)) {
    if (code === undefined) return colours;

    const colourRow = __.findIndex(colours, {code});
    if (status === undefined) {
      if (colourRow < 0) return null;
      return colours[colourRow].value;
    }
    if (colours && colourRow > -1) {

      const colour = getStatusColour(colours[colourRow].value, status);
      if (colour) return colour;
    }
    return props.default||"#808080";
  }
  return null;
}
export default useColour;
export {
  getStatusColour
}